const loginI18n = {
  "fr": {
    "home": {
      "cta": "Retour à l’accueil"
    },
    "title": "Connexion",
    "subtitle": "Accède à ton espace.",
    "form": {
      "email": "Email",
      "password": "Mot de passe",
      "submit": "Se connecter",
      "loading": "Connexion…",
      "forgot": "Mot de passe oublié ?"
    },
    "signup": {
      "prompt": "Pas encore de compte ?",
      "link": "Créer un compte"
    },
    "errors": {
      "emailRequired": "Veuillez saisir votre e-mail.",
      "emailInvalid": "Adresse e-mail invalide.",
      "passwordRequired": "Veuillez saisir votre mot de passe.",
      "requiredBoth": "Veuillez saisir votre e-mail et votre mot de passe.",
      "invalid": "Identifiants invalides.",
      "forbidden": "Accès refusé. Vérifiez vos identifiants.",
      "throttled": "Trop de tentatives. Réessayez dans quelques minutes.",
      "server": "Erreur serveur. Réessayez ultérieurement.",
      "offline": "Impossible de contacter le serveur. Vérifiez votre connexion.",
      "disabled": "Ce compte est désactivé. Contactez le support."
    }
  },
  "en": {
    "home": {
      "cta": "Back to home"
    },
    "title": "Sign in",
    "subtitle": "Access your account.",
    "form": {
      "email": "Email",
      "password": "Password",
      "submit": "Log in",
      "loading": "Signing in…",
      "forgot": "Forgot password?"
    },
    "signup": {
      "prompt": "No account yet?",
      "link": "Create an account"
    },
    "errors": {
      "emailRequired": "Please enter your email.",
      "emailInvalid": "Invalid email address.",
      "passwordRequired": "Please enter your password.",
      "requiredBoth": "Please enter your email and password.",
      "invalid": "Invalid credentials.",
      "forbidden": "Access denied. Check your credentials.",
      "throttled": "Too many attempts. Try again later.",
      "server": "Server error. Please try again later.",
      "offline": "Cannot reach the server. Check your connection.",
      "disabled": "This account is disabled. Please contact support."
    }
  },
  "pl": {
    "home": {
      "cta": "Powrót do strony głównej"
    },
    "title": "Logowanie",
    "subtitle": "Uzyskaj dostęp do swojego konta.",
    "form": {
      "email": "Email",
      "password": "Hasło",
      "submit": "Zaloguj się",
      "loading": "Logowanie…",
      "forgot": "Nie pamiętasz hasła?"
    },
    "signup": {
      "prompt": "Nie masz jeszcze konta?",
      "link": "Utwórz konto"
    },
    "errors": {
      "emailRequired": "Wpisz swój adres e-mail.",
      "emailInvalid": "Nieprawidłowy adres e-mail.",
      "passwordRequired": "Wpisz swoje hasło.",
      "requiredBoth": "Podaj adres e-mail i hasło.",
      "invalid": "Nieprawidłowe dane logowania.",
      "forbidden": "Dostęp zabroniony. Sprawdź dane logowania.",
      "throttled": "Zbyt wiele prób. Spróbuj ponownie za chwilę.",
      "server": "Błąd serwera. Spróbuj ponownie później.",
      "offline": "Brak połączenia z serwerem. Sprawdź połączenie.",
      "disabled": "Konto jest wyłączone. Skontaktuj się z pomocą techniczną."
    }
  },
  "es": {
    "home": {
      "cta": "Volver al inicio"
    },
    "title": "Iniciar sesión",
    "subtitle": "Accede a tu cuenta.",
    "form": {
      "email": "Email",
      "password": "Contraseña",
      "submit": "Iniciar sesión",
      "loading": "Conectando…",
      "forgot": "¿Has olvidado tu contraseña?"
    },
    "signup": {
      "prompt": "¿Aún no tienes cuenta?",
      "link": "Crear una cuenta"
    },
    "errors": {
      "emailRequired": "Por favor, introduce tu email.",
      "emailInvalid": "Dirección de email no válida.",
      "passwordRequired": "Por favor, introduce tu contraseña.",
      "requiredBoth": "Introduce tu email y tu contraseña.",
      "invalid": "Credenciales incorrectas.",
      "forbidden": "Acceso denegado. Comprueba tus datos.",
      "throttled": "Demasiados intentos. Inténtalo de nuevo en unos minutos.",
      "server": "Error del servidor. Inténtalo más tarde.",
      "offline": "No se puede contactar con el servidor. Comprueba tu conexión.",
      "disabled": "Esta cuenta está deshabilitada. Contacta con el soporte."
    }
  },
  "it": {
    "home": {
      "cta": "Torna a casa"
    },
    "title": "Firma",
    "subtitle": "Accedi al tuo account.",
    "form": {
      "email": "Email",
      "password": "Password",
      "submit": "Accedi",
      "loading": "Firma in...",
      "forgot": "Password dimenticata?"
    },
    "signup": {
      "prompt": "Ancora nessun conto?",
      "link": "Creare un account"
    },
    "errors": {
      "emailRequired": "Inserisci la tua email.",
      "emailInvalid": "Indirizzo email non valido.",
      "passwordRequired": "Inserisci la password.",
      "requiredBoth": "Inserisci la tua email e la tua password.",
      "invalid": "credenziali non valide.",
      "forbidden": "Accesso negato. Controlla le credenziali.",
      "throttled": "Troppi tentativi. Riprova più tardi.",
      "server": "Errore del server. Riprova più tardi.",
      "offline": "Non può raggiungere il server. Controlla la connessione.",
      "disabled": "Questo account è disabilitato. Si prega di contattare il supporto."
    }
  },
  "de": {
    "home": {
      "cta": "Zurück nach Hause"
    },
    "title": "Zeichen",
    "subtitle": "Greifen Sie auf Ihr Konto zu.",
    "form": {
      "email": "E-Mail",
      "password": "Passwort",
      "submit": "Anmelden",
      "loading": "Unterzeichnung in...",
      "forgot": "Passwort vergessen?"
    },
    "signup": {
      "prompt": "Noch kein Account?",
      "link": "Erstellen Sie ein Konto"
    },
    "errors": {
      "emailRequired": "Bitte geben Sie Ihre E-Mail ein.",
      "emailInvalid": "Ungültige E-Mail-Adresse.",
      "passwordRequired": "Bitte geben Sie Ihr Passwort ein.",
      "requiredBoth": "Bitte geben Sie Ihre E-Mail und Ihr Passwort ein.",
      "invalid": "Ungültige Zeugnisse.",
      "forbidden": "Zugang verweigert. Überprüfen Sie Ihre Anmeldeinformationen.",
      "throttled": "Zu viele Versuche. Versuchen Sie es später noch einmal.",
      "server": "Serverfehler. Bitte versuchen Sie es später noch einmal.",
      "offline": "Kann den Server nicht erreichen. Überprüfen Sie Ihre Verbindung.",
      "disabled": "Dieses Konto ist deaktiviert. Bitte kontaktieren Sie den Support."
    }
  },
  "pt": {
    "home": {
      "cta": "De volta para casa"
    },
    "title": "Iniciar sessão",
    "subtitle": "Acesse a sua conta.",
    "form": {
      "email": "E- mail",
      "password": "Senha",
      "submit": "Entrar",
      "loading": "A assinar...",
      "forgot": "Esqueceu-se da senha?"
    },
    "signup": {
      "prompt": "Ainda não contaste?",
      "link": "Criar uma conta"
    },
    "errors": {
      "emailRequired": "Introduza o seu email.",
      "emailInvalid": "Endereço de e- mail inválido.",
      "passwordRequired": "Digite sua senha.",
      "requiredBoth": "Digite seu e-mail e senha.",
      "invalid": "Credenciais inválidas.",
      "forbidden": "Acesso negado. Verifica as tuas credenciais.",
      "throttled": "Demasiadas tentativas. Tenta outra vez mais tarde.",
      "server": "Erro no servidor. Por favor, tente novamente mais tarde.",
      "offline": "Não foi possível aceder ao servidor. Verifica a tua ligação.",
      "disabled": "Esta conta está desactivada. Por favor contacte o suporte."
    }
  },
  "cs": {
    "home": {
      "cta": "Zpátky domů"
    },
    "title": "Přihlaste se.",
    "subtitle": "Získejte přístup ke svému účtu.",
    "form": {
      "email": "E-mail",
      "password": "Heslo",
      "submit": "Přihlásit se",
      "loading": "Přihlašuji...",
      "forgot": "Zapomněli jste heslo?"
    },
    "signup": {
      "prompt": "Ještě žádný účet?",
      "link": "Vytvořit účet"
    },
    "errors": {
      "emailRequired": "Prosím zadejte svůj e-mail.",
      "emailInvalid": "Neplatná e-mailová adresa.",
      "passwordRequired": "Prosím zadejte heslo.",
      "requiredBoth": "Zadejte prosím svůj e-mail a heslo.",
      "invalid": "Neplatné doklady.",
      "forbidden": "Přístup zamítnut. Zkontrolujte si doklady.",
      "throttled": "Příliš mnoho pokusů. Zkuste to později.",
      "server": "Chyba serveru. Prosím, zkuste to později.",
      "offline": "Nelze dosáhnout serveru. Zkontrolujte spojení.",
      "disabled": "Tento účet je zakázán. Kontaktujte prosím podporu."
    }
  },
  "nl": {
    "home": {
      "cta": "Terug naar huis"
    },
    "title": "Aanmelden",
    "subtitle": "Toegang tot uw account.",
    "form": {
      "email": "E-mail",
      "password": "Wachtwoord",
      "submit": "Aanmelden",
      "loading": "Aanmelden...",
      "forgot": "Wachtwoord vergeten?"
    },
    "signup": {
      "prompt": "Nog geen rekening?",
      "link": "Een account aanmaken"
    },
    "errors": {
      "emailRequired": "Vul uw e-mail in.",
      "emailInvalid": "Ongeldig e-mailadres.",
      "passwordRequired": "Voer uw wachtwoord in.",
      "requiredBoth": "Voer uw e-mail en wachtwoord in.",
      "invalid": "Ongeldige referenties.",
      "forbidden": "Toegang geweigerd. Controleer je referenties.",
      "throttled": "Te veel pogingen. Probeer het later nog eens.",
      "server": "Serverfout Probeer het later nog eens.",
      "offline": "Kan de server niet bereiken. Controleer je verbinding.",
      "disabled": "Dit account is uitgeschakeld. Neem contact op met ondersteuning."
    }
  }
};

export default loginI18n;
